// @flow
import * as React from 'react';

import styled from 'styled-components';
import colors from '../../../assets/css/colors';
import Tick from '../../../components/Icons/Tick';

const CheckboxItem = styled.label`
	display: block;
	height: 17px;
	width: 17px;
	margin: 0 auto;
	cursor: pointer;
	border: 1px solid ${colors.nrlGreen};
	background-color: #FFFFFF;
	${props => !props.checked && `border-color: ${colors.form_border}`};

	.checkmark {
		display: none;
		pointer-events: none;
		padding: 1px;
	}

	input {
		display: none;

		&:checked ~ .checkmark {
			display: block;
			background: ${colors.nrlGreen};
			height: 100%;
			width: 100%;
		}
	}
`;

type Props = {
	name: string,
	checked?: boolean,
	onChange?: Function,
	value?: any,
};

export const Checkbox = ({ name, checked = false, onChange }: Props) => (
	<CheckboxItem checked={checked}>
		<input defaultChecked={checked} type='checkbox' onChange={onChange} name={name} />
		<Tick className='checkmark' />
	</CheckboxItem>
);

export const CheckboxControlled = ({ name, value, checked = false, onChange, ...rest }: Props) => (
	<CheckboxItem checked={checked} {...rest}>
		<input
			type='checkbox'
			name={name}
			checked={checked}
			value={value}
			onChange={onChange}
		/>
		<Tick className='checkmark' />
	</CheckboxItem>
);

CheckboxControlled.defaultProps = {
	checked: false,
};

export default Checkbox;


// WEBPACK FOOTER //
// ./src/components/Form/Checkbox/index.js